import Cookies from "js-cookie";
import { Decrypt } from "../utils/common";
import { UserCookie } from "../utils/constants";

const getCliCookie = () => {
  try {
    const raw = Cookies.get("_cli");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const getPortalClientId = () => {
  try {
    const userCookie = Cookies.get(UserCookie.CookieName);
    if (userCookie) {
      const parsed = JSON.parse(userCookie);
      const id = parseInt(parsed?.[UserCookie.ClientId], 10);
      if (id > 0) return id;
    }
    const cli = getCliCookie();
    if (!cli?.id) return 0;
    return parseInt(Decrypt(cli.id), 10) || 0;
  } catch {
    return 0;
  }
};

export const getPortalClientLogo = (loggedinUser) => {
  try {
    if (loggedinUser?.[UserCookie.ClientLogo]) return loggedinUser[UserCookie.ClientLogo];
    return getCliCookie()?.logo || "";
  } catch {
    return "";
  }
};

export const getPortalClientUrl = (loggedinUser) => {
  try {
    if (loggedinUser?.[UserCookie.ClientPortalUrl]) return loggedinUser[UserCookie.ClientPortalUrl];
    return getCliCookie()?.purl || "";
  } catch {
    return "";
  }
};
